// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-3661210a] img{max-width:100%}.xxl-page .card[data-v-3661210a],.xxl-page .col[data-v-3661210a]{max-width:932px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
